import OnVisibleInViewport from './OnVisibleInViewport';

export default OnVisibleInViewport;
